'use strict';

var React = require('react');
var Picture = require('../elements/Picture');
var TeaserLink = require('./TeaserLink.jsx');
var TeaserCaption = require('./TeaserCaption.jsx');
var DestinationText = require('./DestinationText.jsx');

class TeaserDestination extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var model = this.props.model;
		var imageType = this.props.imageType;
		var teaserArea = this.props.teaserArea;

		if (!model || Object.keys(model).length === 0) {
			return false;
		}

		var destination = model.destination;

		// TODO: Refactor to classes

		// Style classes for destination teaser
		var destinationImageClass;
		var destinationCaptionClass;
		var destinationDescriptionClass;

		destinationImageClass = "svtse_teaser-type-destination-img";
		destinationCaptionClass = "svtse_teaser-type-destination-caption";
		destinationDescriptionClass = "svtse_teaser-type-destination-caption__description";

		// If teaser is in standard or hero area
		if (teaserArea === "major") {
			destinationImageClass = "svtse_teaser-type-destination-img-minor";
			destinationCaptionClass += " svtse_teaser-type-destination-caption--major";
			destinationDescriptionClass += " svtse_teaser-type-destination-caption__description--major";
		}

		// If teaser is in  hero area
		if (teaserArea === "hero") {
			destinationImageClass = "svtse_teaser-type-destination-img-imax";
			destinationCaptionClass += " svtse_teaser-type-destination-caption--imax";
			destinationDescriptionClass += " svtse_teaser-type-destination-caption__description--imax";
		}

		/* For screen readers, we only show the most relevant information in teaser */
		var ariaText = model.description + ", " + model.title;

		return (
			<TeaserLink model={model} className="svtse_teaser svtse_teaser-type-destination" aria-label={ariaText}>
				<article>
					<div className="svtse_teaser-type-destination-relative">
						<img className="svtse_teaser-type-destination-petals" src="/static/svtse-render/images/petals/petal-left_green600x480.png" alt="Kronblad från SVTs logotyp" />
						<h3 className="svtse_teaser-type-destination-petals__name" aria-hidden="true">
							<DestinationText destination={destination} />
						</h3>
					</div>
					<Picture model={model.cover} type={imageType} imageClass={destinationImageClass} />

					<div className="svtse_teaser-type-destination-relative">
						<div className="svtse_teaser-type-destination-absolute">
							<TeaserCaption className={destinationCaptionClass}>
								<span className={destinationDescriptionClass}>{model.description} </span>
								<span className="svtse_teaser-type-destination-caption__title">{model.title}</span>
							</TeaserCaption>
						</div>
					</div>
				</article>
			</TeaserLink>
		);

	}
}


TeaserDestination.defaultProps = {
	imageType: 'large',
	teaserArea: 'standard'
};

module.exports = TeaserDestination;



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/TeaserDestination.jsx
 **/